import { writeSettingsFields } from './settings-fields';

/** `PATCH /client/settings/fields`: `settings.pooling_geofence`. */
export const editPoolingGeofence = async (pooling_geofence): Promise<any> =>
  writeSettingsFields({ pooling_geofence });
